import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import ProductList from './ProductList';
import ProductActiveFilter from './ProductActiveFilter';
import ProductCategoryFilter from './ProductCategoryFilter';
import ProductCategoryFilterMobile from './ProductCategoryFilterMobile';
import styles from './ProductList-tw-styles';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '../../Generic/Dialog';
import { Button } from '../../Generic/Button';
import configData from '../../../config';
import PLPConstants from './constants';
import Typography from '../../Generic/Typography';
import path from '../../../assets/images/svgImages.svg';
import i18nMessages from '../../../constants/messages/pt-BR';

const spritePath = typeof path === 'string' ? path : path?.src || '';

class ProductListingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDialogOpen: false,
      radioClicked: false,
      widthVar: '',
      isLoaded: false
    };
  }
  componentDidMount() {
    this.setState({
      widthVar: window.innerWidth,
      isLoaded: true
    });
    this.initialStoreSetup();
    window.addEventListener(i18nMessages.resize, () => {
      this.setState({
        widthVar: window.innerWidth,
      });
    });
  }

  componentWillUnmount() {
    const props = this.props;
    props.PLPStore.resetStore();
    window.removeEventListener(i18nMessages.resize, () => {
      this.setState({
        widthVar: window.innerWidth,
      });
    });
  }

  /**
   * prepare data for product and facet category
   */

  filterData = () => {
    const props = this.props;
    const { PLPStore } = props;
    if (typeof props.data == 'undefined') {
      return [];
    }
    let products =
      props.data.productCollection && props.data.productCollection.items;

    PLPStore.totalProdCount = products.length;
    const facet_data = this.getFacetCount(products);

    if (products.length > PLPConstants.lazy_load_consts.per_page) {
      products = products.slice(0, PLPConstants.lazy_load_consts.per_page);
    } else {
      props.PLPStore.load_more_display_state = false;
    }

    return { product_list: products, facet_data: facet_data };
  };

  /**
   * get facet count from available product list
   */

  getFacetCount = products => {
    const props = this.props;
    let facetData = props.data.facetCategoryCollection.items;
    if (facetData == null) {
      return [];
    }
    facetData.forEach(category_object => {
      if (
        category_object.facetCollection &&
        category_object.facetCollection.items.length
      ) {
        category_object.facetCollection.items.forEach(facet_object => {
          if (!facet_object.hasOwnProperty(i18nMessages.product_count)) {
            facet_object.product_count = 0;
          }
          products.length > 0 &&
            products.forEach(product => {
              if (
                product.fecetCollection != null &&
                product.fecetCollection.items.length
              ) {
                const matched_fecet = product.fecetCollection.items.filter(
                  o => o && o.title === facet_object.title
                );
                facet_object.product_count += matched_fecet.length;
              }
            });
        });
        category_object.facet = category_object.facetCollection.items;
      }
    });
    return facetData;
  };

  init_store = () => {
    const {
      bv_data,
      pageContext,
      PLPStore,
      router,
      pageData,
      pageSlug,
      productsData
    } = this.props;
    let { product_list, facet_data } = this.filterData();
  
    product_list.map(product => {
      const ratingAndReviewId = product.ratingAndReviewId;
      const rating_value = bv_data.hasOwnProperty(ratingAndReviewId)
        ? parseFloat(bv_data[ratingAndReviewId].AverageOverallRating)
        : 0;
      const reviewCount = bv_data.hasOwnProperty(ratingAndReviewId)
        ? parseFloat(bv_data[ratingAndReviewId].TotalReviewCount)
        : 0;

      return {
        ...product,
        rating: rating_value,
        ratingCount: reviewCount,
      };
    });

    /**
     * set locale into store
     */
    PLPStore.pageSlug = pageSlug;
    PLPStore.pageData = pageData;
    PLPStore.locale = pageContext.locale;
    PLPStore.compare_product_url = router.asPath;
    /**
     * action to set product list into store
     */

    PLPStore.setInitialProductList(productsData)

    PLPStore.setProductFilterCategories(facet_data);

    PLPStore.resetApplyedFilters();
  };

  initialStoreSetup = () => {
    const { router, PLPStore } = this.props;
    let currentCompareUrl = router.asPath.replace(/\/\s*$/, '');
    if (
      currentCompareUrl.indexOf('?') > -1 &&
      !currentCompareUrl.includes(i18nMessages.facet)
    ) {
      currentCompareUrl = currentCompareUrl.split('?');
      router.hash = router.hash = currentCompareUrl[1];
      router.asPath = currentCompareUrl[0];
    } else if (
      currentCompareUrl.indexOf('?') > -1 &&
      currentCompareUrl.includes(i18nMessages.facet)
    ) {
      currentCompareUrl = currentCompareUrl.split('?');
      router.hash = currentCompareUrl[1];
      router.asPath = currentCompareUrl[0];
    } else {
      router.asPath = currentCompareUrl;
      router.hash = '';
    }
    this.init_store();
    PLPStore.setFilter(router.asPath, decodeURI(router.hash));
  };

  addFilter = (d, ftr) => {
    const { PLPStore } = this.props;
    PLPStore.addFilters(d, ftr);
  };

  handleDialogOpen = () => {
    const { filterDialogOpen: filterDialogStatus } = this.state;
    this.setState({
      filterDialogOpen: !filterDialogStatus,
      radioClicked: false,
    });
  };
  handleRadioClickedState = chk => {
    this.setState({
      radioClicked: chk,
    });
  };
  handleApplyDialog = () => {
    const { radioClicked } = this.state;
    const { PLPStore } = this.props;
    if (radioClicked) PLPStore.redirectOnFilters();
    else PLPStore.getfilterQuery();
    this.handleDialogOpen();
  };
  onReset = pageType => {
    const { PLPStore, data } = this.props;
    const { selectedFilters } = PLPStore;
    if (selectedFilters.length > 1) PLPStore.resetFilterByCategory(pageType);
    else if (
      selectedFilters.length === 1 &&
      data.productListCollection.items &&
      !data.productListCollection.items[0].facet
    ) {
      PLPStore.resetFilterByCategory(pageType);
    }
  };
  render() {
    const props = this.props;
    const { locale, PLPStore, router, data } = props;
    const { filterDialogOpen, widthVar, isLoaded } = this.state;
    const { selectedFilters } = PLPStore;
    const i18nMessages = require(`../../../constants/messages/${locale}`);
    const pageType =
      data.productListCollection.items &&
      data.productListCollection.items[0].facetCategory;
    let activeResetStyle = '';
    if (selectedFilters.length > 1)
      activeResetStyle = styles?.dialog?.activeResetStyle;
    else if (
      selectedFilters.length === 1 &&
      data.productListCollection.items &&
      !data.productListCollection.items[0].facet
    ) {
      activeResetStyle = styles?.dialog?.activeResetStyle;
    }

    /**
     *  Show Recent view
     */

    return (
      <div className={classNames(styles?.productListPage?.mainWrapper)}>
        <div className={classNames(styles?.productListPage?.container)}>
          <div className={classNames(styles?.productListPage?.sectionWrapper)}>
            {isLoaded ? 
            (widthVar > configData.screenWidth.tabWidthFilter && (
            <div className={classNames(styles?.productListPage?.filterSection)}>
              <ProductCategoryFilter
                addFilter={this.addFilter}
                filters={PLPStore.filters}
                clearFilter={PLPStore.clearFilter}
                {...this.props}
                hashUrl={PLPStore.url_hash_string}
                router={router}
              />
            </div>
            )) : (
              <div className={classNames(styles?.productListPage?.filterSection)}>
                <ProductCategoryFilter
                  addFilter={this.addFilter}
                  filters={PLPStore.filters}
                  clearFilter={PLPStore.clearFilter}
                  {...this.props}
                  hashUrl={PLPStore.url_hash_string}
                  router={router}
                />
              </div>
            )}
            {isLoaded ? 
            (widthVar <= configData.screenWidth.tabWidthFilter && (
            <div
              className={classNames(
                styles?.productListPage?.filterSectionMobile
              )}
            >
              <Button 
                onClick={this.handleDialogOpen} 
                aria-label="Abrir filtros de produtos"
                aria-expanded={filterDialogOpen}
                aria-controls="filter-dialog"
              >
                <svg className={classNames(styles.searchIcon)}>
                  <use xlinkHref={`${spritePath}#filter`} />
                </svg>
              </Button>
              <Dialog
                modalStyle={classNames(styles?.dialog?.mainDiv)}
                onClose={this.handleDialogOpen}
                open={filterDialogOpen}
                aria-labelledby="filter-dialog-title"
                role="menu"
              >
                <DialogTitle 
                  id="filter-dialog-title"
                  className={styles?.dialog?.title} 
                  component="div"
                >
                  <Button
                    className={styles?.dialog?.closeButton}
                    onClick={this.handleDialogOpen}
                    aria-label="Fechar diálogo de filtros"
                  >
                    <span className={styles?.dialog?.closeSpan}>×</span>
                  </Button>
                </DialogTitle>
                <DialogContent>
                  <ProductCategoryFilterMobile
                    addFilter={this.addFilter}
                    filters={PLPStore.filters}
                    clearFilter={PLPStore.clearFilter}
                    {...this.props}
                    hashUrl={PLPStore.url_hash_string}
                    router={router}
                    handleRadioClickedState={this.handleRadioClickedState}
                  />
                </DialogContent>
                <DialogActions>
                  <div className={styles?.dialog?.actionButtonContainer}>
                    <Button
                      className={classNames(
                        styles?.dialog?.actionButton,
                        activeResetStyle
                      )}
                      onClick={() => this.onReset(pageType)}
                    >
                      <span className={styles?.dialog?.actionSpan}>
                        {i18nMessages.reset}
                      </span>
                    </Button>
                    <Button
                      className={styles?.dialog?.applyButton}
                      onClick={this.handleApplyDialog}
                      aria-label="Aplicar filtros"
                    >
                      <span className={styles?.dialog?.actionSpan}>
                        {i18nMessages.apply}
                      </span>
                    </Button>
                  </div>
                </DialogActions>
              </Dialog>
            </div>
            )): (
              <div
                className={classNames(
                  styles?.productListPage?.filterSectionMobile
                )}
              >
                <Button 
                  onClick={this.handleDialogOpen} 
                  aria-label="Abrir filtros de produtos"
                  aria-expanded={filterDialogOpen}
                  aria-controls="filter-dialog"
                >
                  <svg className={classNames(styles.searchIcon)}>
                    <use xlinkHref={`${spritePath}#filter`} />
                  </svg>
                </Button>
                <Dialog
                  modalStyle={classNames(styles?.dialog?.mainDiv)}
                  onClose={this.handleDialogOpen}
                  open={filterDialogOpen}
                  aria-labelledby="filter-dialog-title"
                >
                  <DialogTitle 
                    id="filter-dialog-title"
                    className={styles?.dialog?.title} 
                    component="div"
                  >
                    <Button
                      className={styles?.dialog?.closeButton}
                      onClick={this.handleDialogOpen}
                      aria-label="Fechar diálogo de filtros"
                    >
                      <span className={styles?.dialog?.closeSpan}>×</span>
                    </Button>
                  </DialogTitle>
                  <DialogContent>
                    <ProductCategoryFilterMobile
                      addFilter={this.addFilter}
                      filters={PLPStore.filters}
                      clearFilter={PLPStore.clearFilter}
                      {...this.props}
                      hashUrl={PLPStore.url_hash_string}
                      router={router}
                      handleRadioClickedState={this.handleRadioClickedState}
                    />
                  </DialogContent>
                  <DialogActions>
                    <div className={styles?.dialog?.actionButtonContainer}>
                      <Button
                        className={classNames(
                          styles?.dialog?.actionButton,
                          activeResetStyle
                        )}
                        onClick={() => this.onReset(pageType)}
                      >
                        <span className={styles?.dialog?.actionSpan}>
                          {i18nMessages.reset}
                        </span>
                      </Button>
                      <Button
                        className={styles?.dialog?.applyButton}
                        onClick={this.handleApplyDialog}
                      >
                        <span className={styles?.dialog?.actionSpan}>
                          {i18nMessages.apply}
                        </span>
                      </Button>
                    </div>
                  </DialogActions>
                </Dialog>
              </div>
            )}
            <div
              className={classNames(styles?.productListPage?.prodCompareSection)}
            >
              <div className={classNames(styles?.productListPage?.typeStyle)}>
                {data.productListCollection.items &&
                  data.productListCollection.items[0].facetCategory && (
                    <Typography
                      className={classNames(styles.typoProdType)}
                      component="span"
                    >
                      {data.productListCollection.items[0].facetCategory.title}:
                    </Typography>
                  )}
                {data.productListCollection.items &&
                  data.productListCollection.items[0].facet && (
                    <Typography
                      className={classNames(styles.typoProdName)}
                      component="span"
                    >
                      {data.productListCollection.items[0].facet.title}
                    </Typography>
                  )}
                {data.productListCollection.items &&
                  !data.productListCollection.items[0].facetCategory &&
                  !data.productListCollection.items[0].facet && (
                    <Typography
                      className={classNames(styles.typoProdName)}
                      component="span"
                    >
                      {i18nMessages.all_products}
                    </Typography>
                  )}
              </div>
              <div className={classNames(styles?.activeFilter?.wrapper)}>
                {props.PLPStore.selectedFilters.length > 0 && (
                  <ProductActiveFilter
                    locale={locale}
                    clearFilter={PLPStore.clearFilter}
                    clearAllFilter={PLPStore.clearAllFilter}
                    filters={PLPStore.selectedFilters}
                    pageFacet={
                      data.productListCollection.items &&
                      data.productListCollection.items[0].facet
                    }
                  />
                )}
              </div>
              <div>
                <ProductList PLPStore={PLPStore} {...this.props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default inject(['PLPStore'])(observer(ProductListingPage));
